import React, { useState, useContext } from "react";
import { useHistory, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import Alert from "./Alert";

const Login = () => {

  const history = useHistory();
  const { setUser } = useContext(AuthContext);

  const initialState = {
    fields: {
      email: "",
      password: ""
    },
    alert: {
      message: "",
      isSuccess: false,
    }
  };

  const [fields, setFields] = useState(initialState.fields);
  const [alert, setAlert] = useState(initialState.alert);

  const handleFieldChange = (event) => {
    setFields((prev) => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };

  const handleLogin = (event) => {
    event.preventDefault();
    firebase.auth().signInWithEmailAndPassword(fields.email, fields.password)
      .then((userCredential) => {
        // Signed in
        // console.log(userCredential);
        setUser(userCredential.user);
        history.push("/");
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        if (errorCode === "auth/user-not-found") {
          setAlert({
            message: "We don't have an account with that email address.",
          })
        } else {
          setAlert({
            message: "Password not recognised.",
          })
        }
      });
  };

  return (
    <div className="container">
      <section>
        <article>
          <h2 className="heading center">Sign into your account</h2>
          <form onSubmit={handleLogin} className="login-form" action="" method="post">
            
            <Alert message={alert.message} />
            <div>
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                name="email"
                id="email"
                value={fields.email}
                autoFocus
                onChange={handleFieldChange}
              />
            </div>

            <div>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                id="password"               
                value={fields.password}
                onChange={handleFieldChange}
              />
            </div>
              
            <div>
              <button
                type="submit"
                className="form-button"
              >Sign in
              </button>
            </div>

            <div className="no-account">
              <p>
                Don't have an account?
                <Link to="/register" className="button-link">Sign up</Link>
              </p>
            </div>
            
          </form>
        </article>
      </section>
    </div>
  )

}

export default Login;